import { render, staticRenderFns } from "./IconInfoBox.vue?vue&type=template&id=d2b9f888&scoped=true&"
import script from "./IconInfoBox.vue?vue&type=script&lang=js&"
export * from "./IconInfoBox.vue?vue&type=script&lang=js&"
import style0 from "./IconInfoBox.vue?vue&type=style&index=0&id=d2b9f888&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2b9f888",
  null
  
)

export default component.exports